const $ = window.jQuery;
const wpmdb = window.wpmdb;
const ajaxurl = window.ajaxurl;
const _ = window._;

$( function() {
	$( 'body' ).on( 'wpmdb_done', async function() {
		if ( '1' !== wpmdb_data.allow_tracking ) {
			return false;
		}

		let args = {
			action: 'wpmdb_track_migration_complete',
			nonce: wpmdb_data.nonces.send_migration_complete,
			migration_state_id: wpmdb.migration_state_id
		};

		try {
			const response = await $.ajax( {
				url: ajaxurl,
				type: 'POST',
				cache: false,
				data: args
			} );

		} catch ( error ) {
			console.error( error );
		}
	} );

	$.wpmdb.add_action( 'wpmdb_migration_initiated', async function() {
		if ( '1' !== wpmdb_data.allow_tracking ) {
			return false;
		}

		let args = {
			action: 'wpmdb_maybe_collect_data',
			nonce: wpmdb_data.nonces.track_usage,
			migration_state_id: wpmdb.migration_state_id
		};

		try {
			const response = await $.ajax( {
				url: ajaxurl,
				type: 'POST',
				cache: false,
				data: args
			} );

		} catch ( error ) {
			console.error( error );
		}
	} );
} );



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/usage-tracking.js